/**
 * Render de las plantillas de recordatorio, igual que lo hace el backend:
 * {variable} se reemplaza por su valor y las desconocidas quedan tal cual.
 */
export function renderTemplate(template: string, values: Record<string, string>): string {
  return template.replace(/\{([a-zA-Z_]+)\}/g, (match, key) =>
    key in values ? values[key] : match
  );
}

// Datos de ejemplo para la vista previa del editor
export const PREVIEW_VALUES: Record<string, string> = {
  veterinaria: 'Veterinaria Anima',
  cliente: 'Nadia',
  mascota: 'Toby',
  fecha: '20/08/2026',
  hora: '10:30',
  motivo: 'Control general',
  vacuna: 'Antirrábica',
  servicio: 'Baño y corte',
  tipo: 'Cirugía',
  indicaciones: 'Ayuno de 8 horas.',
};
